module.exports = __webpack_public_path__ + "static/media/Calory_Icon.ff3c57b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Calory_Icon.png
// module id = 602
// module chunks = 0